import type {ReactAction} from '@netx/core/bootstrap';

/**
 * Flatten children into the main actions array
 * @example
 * action 1
 *  - action 1.1
 *  - action 1.2
 *   - action 1.2.1
 *   - action 1.2.2
 *  - action 1.3
 *
 * // ->
 *
 * action 1
 * action 1.1
 * action 1.2
 * action 1.2.1
 * action 1.2.2
 * action 1.3
 */
export const unwrapActionChildren = (
	actions: Array<ReactAction | ReactAction[]>,
	depth = 0,
): Array<ReactAction | ReactAction[]> => {
	return actions.reduce<Array<ReactAction | ReactAction[]>>((accum, action) => {
		if (Array.isArray(action))
			return [...accum, ...unwrapActionChildren(action)];
		const {children, ...rest} = action;
		const hasChildren = !!children?.length;
		return [
			...accum,
			{...rest, depth, proxy: hasChildren},
			...(hasChildren ? unwrapActionChildren(children, depth + 1) : []),
		];
	}, []);
};
